module.exports = __webpack_public_path__ + "img/desktop.b4d9cf0f.jpeg";